export default {"src":"/_next/static/media/open.0910ee92.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};